<template>
  <div>
    <Assistant_teacher_bar />
    <v-container fluid>
      <!-- หัวข้อหลัก -->
      <v-row class="mb-4">
        <v-col cols="12">
          <div class="d-flex align-center justify-space-between">
            <div>
              <h1 class="font-weight-bold primary--text">
                <v-icon large color="primary" class="mr-2"
                  >mdi-chart-box</v-icon
                >
                Dashboard รายงานใบอนุญาตประกอบวิชาชีพ
              </h1>
              <p class="grey--text mt-2">
                ภาพรวมข้อมูลและสถิติการอนุมัติใบอนุญาต
              </p>
            </div>
            <div>

              <v-btn
                color="primary"
                large
                @click="exportToExcel"
                :loading="exporting"
                class="mr-2"
              >
                <v-icon left>mdi-file-excel</v-icon>
                ส่งออก Excel
              </v-btn>
              <v-btn
                color="secondary"
                large
                outlined
                @click="loadStatistics"
                :loading="loading"
              >
                <v-icon left>mdi-refresh</v-icon>
                รีเฟรช
              </v-btn>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <PeriodAssTeach_license />
        </v-col>
        <v-col cols="12" md="6">
          <PeriodAssTeach_license_college />
        </v-col>
        <v-col cols="12">
          <Specializedlicensetypescomponentdialog/>
        </v-col>
      </v-row>

      <!-- สถิติภาพรวม -->
      <v-row class="mb-4">
        <v-col cols="12" sm="6" md="3">
          <v-card
            class="stat-card"
            elevation="3"
            hover
            @click="filterByStatus('all')"
          >
            <v-card-text>
              <div class="d-flex align-center justify-space-between">
                <div>
                  <div class="text-h3 font-weight-bold primary--text">
                    {{ stats.total }}
                  </div>
                  <div class="text-subtitle-1 grey--text mt-1">
                    รายงานทั้งหมด
                  </div>
                  <v-progress-linear
                    color="primary"
                    value="100"
                    height="4"
                    class="mt-3"
                    rounded
                  ></v-progress-linear>
                </div>
                <v-avatar size="80" color="primary lighten-4">
                  <v-icon size="48" color="primary">mdi-certificate</v-icon>
                </v-avatar>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="stat-card"
            elevation="3"
            hover
            @click="filterByStatus('pending')"
          >
            <v-card-text>
              <div class="d-flex align-center justify-space-between">
                <div>
                  <div class="text-h3 font-weight-bold warning--text">
                    {{ stats.pending }}
                  </div>
                  <div class="text-subtitle-1 grey--text mt-1">รอตรวจสอบ</div>
                  <v-progress-linear
                    color="warning"
                    :value="getPercentage(stats.pending)"
                    height="4"
                    class="mt-3"
                    rounded
                  ></v-progress-linear>
                </div>
                <v-avatar size="80" color="warning lighten-4">
                  <v-icon size="48" color="warning">mdi-clock-alert</v-icon>
                </v-avatar>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="stat-card"
            elevation="3"
            hover
            @click="filterByStatus('approved')"
          >
            <v-card-text>
              <div class="d-flex align-center justify-space-between">
                <div>
                  <div class="text-h3 font-weight-bold success--text">
                    {{ stats.approved }}
                  </div>
                  <div class="text-subtitle-1 grey--text mt-1">อนุมัติแล้ว</div>
                  <v-progress-linear
                    color="success"
                    :value="getPercentage(stats.approved)"
                    height="4"
                    class="mt-3"
                    rounded
                  ></v-progress-linear>
                </div>
                <v-avatar size="80" color="success lighten-4">
                  <v-icon size="48" color="success">mdi-check-circle</v-icon>
                </v-avatar>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="stat-card"
            elevation="3"
            hover
            @click="filterByStatus('rejected')"
          >
            <v-card-text>
              <div class="d-flex align-center justify-space-between">
                <div>
                  <div class="text-h3 font-weight-bold error--text">
                    {{ stats.rejected }}
                  </div>
                  <div class="text-subtitle-1 grey--text mt-1">
                    ส่งกลับแก้ไข
                  </div>
                  <v-progress-linear
                    color="error"
                    :value="getPercentage(stats.rejected)"
                    height="4"
                    class="mt-3"
                    rounded
                  ></v-progress-linear>
                </div>
                <v-avatar size="80" color="error lighten-4">
                  <v-icon size="48" color="error">mdi-close-circle</v-icon>
                </v-avatar>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Charts -->
      <v-row class="mb-4">
        <!-- Approval Status Chart -->
        <v-col cols="12" md="6">
          <v-card elevation="3">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-chart-donut</v-icon>
              สถิติการอนุมัติตามสถานะ
            </v-card-title>
            <v-card-text>
              <apexchart
                type="donut"
                height="350"
                :options="approvalChartOptions"
                :series="approvalChartSeries"
              ></apexchart>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- License Type Chart -->
        <v-col cols="12" md="6">
          <v-card elevation="3">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-chart-bar</v-icon>
              สถิติตามประเภทใบอนุญาต
            </v-card-title>
            <v-card-text>
              <apexchart
                type="bar"
                height="350"
                :options="licenseTypeChartOptions"
                :series="licenseTypeChartSeries"
              ></apexchart>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Trend Chart -->
        <v-col cols="12">
          <v-card elevation="3">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-chart-line</v-icon>
              แนวโน้มการอนุมัติรายเดือน
              <v-spacer></v-spacer>
              <v-btn-toggle
                v-model="trendPeriod"
                mandatory
                dense
                dark
                @change="loadTrendData"
              >
                <v-btn small value="3">3 เดือน</v-btn>
                <v-btn small value="6">6 เดือน</v-btn>
                <v-btn small value="12">12 เดือน</v-btn>
              </v-btn-toggle>
            </v-card-title>
            <v-card-text>
              <apexchart
                type="area"
                height="350"
                :options="trendChartOptions"
                :series="trendChartSeries"
              ></apexchart>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- License Status Chart -->
        <v-col cols="12" md="6">
          <v-card elevation="3">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-chart-pie</v-icon>
              สถิติสถานะใบอนุญาต
            </v-card-title>
            <v-card-text>
              <apexchart
                type="pie"
                height="350"
                :options="licenseStatusChartOptions"
                :series="licenseStatusChartSeries"
              ></apexchart>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- College Performance Chart -->
        <v-col cols="12" md="6">
          <v-card elevation="3">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-school</v-icon>
              อันดับวิทยาลัยที่มีรายงานมากที่สุด (Top 10)
            </v-card-title>
            <v-card-text>
              <apexchart
                type="bar"
                height="350"
                :options="collegeChartOptions"
                :series="collegeChartSeries"
              ></apexchart>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- ตัวกรองและตาราง -->
      <v-card elevation="3">
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-shield-check</v-icon>
          รายงานใบอนุญาตประกอบวิชาชีพ
        </v-card-title>

        <!-- ตัวกรอง -->
        <v-card-text>
          <v-expansion-panels class="mb-4">
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon left>mdi-filter</v-icon>
                  ตัวกรองข้อมูล
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="filter.approval_status"
                      :items="approvalStatusOptions"
                      label="สถานะการอนุมัติ"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-check-circle"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-select
                      v-model="filter.license_status"
                      :items="licenseStatusOptions"
                      label="สถานะใบอนุญาต"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-certificate"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-autocomplete
                      v-model="filter.license_type_id"
                      :items="licenseTypes"
                      item-text="license_type_name"
                      item-value="license_type_id"
                      label="ประเภทใบอนุญาต"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-certificate-outline"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="filter.search_text"
                      label="ค้นหา (ชื่อ/เลขบัตร)"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-magnify"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="text-right">
                    <v-btn
                      color="primary"
                      @click="loadLicenses"
                      :loading="loading"
                    >
                      <v-icon left>mdi-magnify</v-icon>
                      ค้นหา
                    </v-btn>
                    <v-btn color="grey" text @click="clearFilter" class="ml-2">
                      <v-icon left>mdi-refresh</v-icon>
                      ล้างตัวกรอง
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- ตารางแสดงข้อมูล -->
          <v-data-table
            :headers="headers"
            :items="licenses"
            :loading="loading"
            :search="searchTable"
            class="elevation-1"
            :items-per-page="15"
            :footer-props="{
              'items-per-page-options': [10, 15, 25, 50]
            }"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>
                  <v-icon left>mdi-format-list-bulleted</v-icon>
                  รายการทั้งหมด ({{ licenses.length }})
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="searchTable"
                  append-icon="mdi-magnify"
                  label="ค้นหาในตาราง"
                  single-line
                  hide-details
                  dense
                  outlined
                ></v-text-field>
              </v-toolbar>
            </template>

            <template v-slot:item.full_name="{ item }">
              <div class="d-flex align-center">
                <v-avatar size="36" class="mr-2" color="primary">
                  <span class="white--text text-subtitle-2">{{
                    getInitials(item.full_name)
                  }}</span>
                </v-avatar>
                <div>
                  <div class="font-weight-medium">{{ item.full_name }}</div>
                  <div class="caption grey--text">{{ item.mt_id_card }}</div>
                </div>
              </div>
            </template>

            <template v-slot:item.license_type_name="{ item }">
              <div>
                <div class="font-weight-medium">
                  {{ item.license_type_name }}
                </div>
                <div class="caption text--secondary">
                  {{ item.license_number }}
                </div>
              </div>
            </template>

            <template v-slot:item.expiry_date="{ item }">
              <div>
                <div>{{ formatDate(item.expiry_date) }}</div>
                <v-chip
                  v-if="item.days_until_expiry !== null"
                  x-small
                  :color="getExpiryColor(item.days_until_expiry)"
                  text-color="white"
                  class="mt-1"
                >
                  {{ getExpiryText(item.days_until_expiry) }}
                </v-chip>
              </div>
            </template>

            <template v-slot:item.license_status="{ item }">
              <v-chip
                small
                :color="getLicenseStatusColor(item.license_status)"
                text-color="white"
              >
                {{ getLicenseStatusText(item.license_status) }}
              </v-chip>
            </template>

            <template v-slot:item.approval_status="{ item }">
              <v-chip
                small
                :color="getApprovalStatusColor(item.approval_status)"
                text-color="white"
              >
                <v-icon left small>{{
                  getApprovalStatusIcon(item.approval_status)
                }}</v-icon>
                {{ getApprovalStatusText(item.approval_status) }}
              </v-chip>
            </template>

            <template v-slot:item.license_file="{ item }">
              <v-btn
                v-if="item.license_file"
                icon
                small
                color="primary"
                @click="viewFile(item.license_file)"
              >
                <v-icon>mdi-file-document</v-icon>
              </v-btn>
              <span v-else class="grey--text">-</span>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    small
                    color="info"
                    class="mr-2"
                    @click="viewDetail(item)"
                    v-on="on"
                  >
                    mdi-eye
                  </v-icon>
                </template>
                <span>ดูรายละเอียด</span>
              </v-tooltip>

              <v-tooltip bottom v-if="item.approval_status === 'pending'">
                <template v-slot:activator="{ on }">
                  <v-icon
                    small
                    color="success"
                    class="mr-2"
                    @click="openApprovalDialog(item, 'approved')"
                    v-on="on"
                  >
                    mdi-check-circle
                  </v-icon>
                </template>
                <span>อนุมัติ</span>
              </v-tooltip>

              <v-tooltip bottom v-if="item.approval_status === 'pending' || item.approval_status==='approved'">
                <template v-slot:activator="{ on }">
                  <v-icon
                    small
                    color="error"
                    @click="openApprovalDialog(item, 'rejected')"
                    v-on="on"
                  >
                    mdi-close-circle
                  </v-icon>
                </template>
                <span>ส่งกลับแก้ไข</span>
              </v-tooltip>

               <v-tooltip bottom v-if="item.license_file">
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  color="error"
                  class="mr-2"
                  @click="deleteItem(item)"
                  v-on="on"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>ลบ</span>
            </v-tooltip>

            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <!-- Dialog อนุมัติ/ส่งกลับ -->
      <v-dialog v-model="dialogApproval" max-width="600px" persistent>
        <v-card>
          <v-card-title
            :class="
              approvalAction === 'approved'
                ? 'success white--text'
                : 'error white--text'
            "
          >
            <v-icon left color="white">
              {{
                approvalAction === "approved"
                  ? "mdi-check-circle"
                  : "mdi-close-circle"
              }}
            </v-icon>
            {{
              approvalAction === "approved" ? "อนุมัติรายงาน" : "ส่งกลับแก้ไข"
            }}
          </v-card-title>

          <v-card-text class="pt-4">
            <v-alert
              :type="approvalAction === 'approved' ? 'success' : 'warning'"
              text
              prominent
              border="left"
            >
              <div class="font-weight-medium">
                {{
                  approvalAction === "approved"
                    ? "ยืนยันการอนุมัติรายงานใบอนุญาต"
                    : "ส่งรายงานกลับเพื่อแก้ไข"
                }}
              </div>
              <div class="mt-2">
                <strong>ครูผู้ช่วย:</strong> {{ selectedItem.full_name }}<br />
                <strong>ประเภทใบอนุญาต:</strong>
                {{ selectedItem.license_type_name }}<br />
                <strong>เลขที่:</strong> {{ selectedItem.license_number }}
              </div>
            </v-alert>

            <v-form ref="approvalForm" v-model="approvalValid">
              <v-textarea
                v-model="approvalData.reviewer_remarks"
                :label="
                  approvalAction === 'approved'
                    ? 'หมายเหตุ (ถ้ามี)'
                    : 'เหตุผลที่ส่งกลับแก้ไข *'
                "
                outlined
                :rules="approvalAction === 'rejected' ? [rules.required] : []"
                rows="4"
                prepend-inner-icon="mdi-note-text"
                hint="โปรดระบุรายละเอียดเพิ่มเติม"
                persistent-hint
              ></v-textarea>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="dialogApproval = false"
              >ยกเลิก</v-btn
            >
            <v-btn
              :color="approvalAction === 'approved' ? 'success' : 'error'"
              @click="submitApproval"
              :loading="approving"
            >
              <v-icon left>
                {{
                  approvalAction === "approved" ? "mdi-check" : "mdi-arrow-left"
                }}
              </v-icon>
              {{ approvalAction === "approved" ? "อนุมัติ" : "ส่งกลับแก้ไข" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog แสดงรายละเอียด -->
      <v-dialog v-model="dialogDetail" max-width="800px">
        <v-card v-if="selectedItem">
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-information</v-icon>
            รายละเอียดใบอนุญาต
          </v-card-title>

          <v-card-text class="pt-4">
            <v-row>
              <!-- ข้อมูลครูผู้ช่วย -->
              <v-col cols="12">
                <v-card outlined>
                  <v-card-subtitle class="font-weight-bold">
                    <v-icon small class="mr-1">mdi-account</v-icon>
                    ข้อมูลครูผู้ช่วย
                  </v-card-subtitle>
                  <v-card-text>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >ชื่อ-นามสกุล</v-list-item-subtitle
                          >
                          <v-list-item-title class="text-h6">{{
                            selectedItem.full_name
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >เลขบัตรประชาชน</v-list-item-subtitle
                          >
                          <v-list-item-title>{{
                            selectedItem.id_card
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- ข้อมูลใบอนุญาต -->
              <v-col cols="12">
                <v-card outlined>
                  <v-card-subtitle class="font-weight-bold">
                    <v-icon small class="mr-1">mdi-certificate</v-icon>
                    ข้อมูลใบอนุญาต
                  </v-card-subtitle>
                  <v-card-text>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >ประเภทใบอนุญาต</v-list-item-subtitle
                          >
                          <v-list-item-title>{{
                            selectedItem.license_type_name
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >เลขที่ใบอนุญาต</v-list-item-subtitle
                          >
                          <v-list-item-title>{{
                            selectedItem.license_number
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >หน่วยงานที่ออก</v-list-item-subtitle
                          >
                          <v-list-item-title>{{
                            selectedItem.issuer_organization || "-"
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >วันที่ออกใบอนุญาต</v-list-item-subtitle
                          >
                          <v-list-item-title>{{
                            formatDate(selectedItem.issue_date)
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >วันที่หมดอายุ</v-list-item-subtitle
                          >
                          <v-list-item-title>
                            {{ formatDate(selectedItem.expiry_date) }}
                            <v-chip
                              v-if="selectedItem.days_until_expiry !== null"
                              x-small
                              class="ml-2"
                              :color="
                                getExpiryColor(selectedItem.days_until_expiry)
                              "
                              text-color="white"
                            >
                              {{
                                getExpiryText(selectedItem.days_until_expiry)
                              }}
                            </v-chip>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >สถานะใบอนุญาต</v-list-item-subtitle
                          >
                          <v-list-item-title>
                            <v-chip
                              small
                              :color="
                                getLicenseStatusColor(
                                  selectedItem.license_status
                                )
                              "
                              text-color="white"
                            >
                              {{
                                getLicenseStatusText(
                                  selectedItem.license_status
                                )
                              }}
                            </v-chip>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <!-- เพิ่มส่วนไฟล์แนบตรงนี้ -->
                      <v-list-item v-if="selectedItem.license_file">
                        <v-list-item-content>
                          <v-list-item-subtitle>ไฟล์แนบ</v-list-item-subtitle>
                          <v-list-item-title>
                            <v-btn
                              small
                              color="primary"
                              outlined
                              @click="viewFile(selectedItem.license_file)"
                            >
                              <v-icon left small>mdi-file-document</v-icon>
                              ดูไฟล์
                            </v-btn>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- สถานะการอนุมัติ -->
              <v-col cols="12">
                <v-card
                  outlined
                  :color="
                    getApprovalStatusColor(selectedItem.approval_status) +
                      ' lighten-5'
                  "
                >
                  <v-card-subtitle class="font-weight-bold">
                    <v-icon small class="mr-1">mdi-clipboard-check</v-icon>
                    สถานะการอนุมัติ
                  </v-card-subtitle>
                  <v-card-text>
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle>สถานะ</v-list-item-subtitle>
                          <v-list-item-title>
                            <v-chip
                              :color="
                                getApprovalStatusColor(
                                  selectedItem.approval_status
                                )
                              "
                              text-color="white"
                            >
                              <v-icon left small>{{
                                getApprovalStatusIcon(
                                  selectedItem.approval_status
                                )
                              }}</v-icon>
                              {{
                                getApprovalStatusText(
                                  selectedItem.approval_status
                                )
                              }}
                            </v-chip>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>

                      <v-list-item v-if="selectedItem.reviewer_name">
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >ผู้ตรวจสอบ</v-list-item-subtitle
                          >
                          <v-list-item-title>{{
                            selectedItem.reviewer_name
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-if="selectedItem.review_date">
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >วันที่ตรวจสอบ</v-list-item-subtitle
                          >
                          <v-list-item-title>{{
                            formatDate(selectedItem.review_date)
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-if="selectedItem.reviewer_remarks">
                        <v-list-item-content>
                          <v-list-item-subtitle
                            >หมายเหตุจากผู้ตรวจสอบ</v-list-item-subtitle
                          >
                          <v-list-item-title>{{
                            selectedItem.reviewer_remarks
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="selectedItem.approval_status === 'pending'"
              color="success"
              @click="openApprovalDialog(selectedItem, 'approved')"
            >
              <v-icon left>mdi-check-circle</v-icon>
              อนุมัติ
            </v-btn>
            <v-btn
              v-if="selectedItem.approval_status === 'pending'"
              color="error"
              @click="openApprovalDialog(selectedItem, 'rejected')"
            >
              <v-icon left>mdi-close-circle</v-icon>
              ส่งกลับแก้ไข
            </v-btn>
            <v-btn color="grey" text @click="dialogDetail = false">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="pdflicense_filedialog" max-width="80%">
        <v-card class="" elevation="2">
          <embed
            :src="'/HRvecLicenseTeach/' + license_file"
            width="100%"
            height="700px"
          />
        </v-card>
      </v-dialog>

      <!-- Snackbar -->
      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="3000"
        top
      >
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<!-- script section -->
<script>
import Assistant_teacher_bar from "../../../components/admin/assistant_teacher_bar.vue";
import PeriodAssTeach_license from "../../../components/admin/periodAssTeach_license.vue";
import PeriodAssTeach_license_college from "../../../components/admin/periodAssTeach_license_college.vue";
import Specializedlicensetypescomponentdialog from "../../../components/admin/Specializedlicensetypescomponentdialog.vue";

export default {
  components: {
    Assistant_teacher_bar,
    PeriodAssTeach_license,
    Specializedlicensetypescomponentdialog,
    PeriodAssTeach_license_college
  },
  name: "AdminLicenseDashboard",
  data() {
    return {
      ApiKey: "HRvec2021",
      pdflicense_filedialog: false,
      license_file: "",
      userSession: null,
      currentUser: null,
      loading: false,
      approving: false,
      exporting: false,
      approvalValid: false,
      dialogApproval: false,
      dialogDetail: false,
      searchTable: "",
      trendPeriod: "6",

      licenses: [],
      licenseTypes: [],
      selectedItem: {},
      approvalAction: null,

      stats: {
        total: 0,
        pending: 0,
        approved: 0,
        rejected: 0
      },

      // Chart Data
      approvalChartSeries: [],
      licenseTypeChartSeries: [],
      trendChartSeries: [],
      licenseStatusChartSeries: [],
      collegeChartSeries: [],

      // ตัวกรอง
      filter: {
        approval_status: null,
        license_status: null,
        license_type_id: null,
        search_text: ""
      },

      // ข้อมูลการอนุมัติ
      approvalData: {
        license_id: null,
        approval_status: null,
        reviewer_remarks: "",
        approved_by: "",
        review_date: new Date().toISOString().substr(0, 10)
      },

      // Options
      approvalStatusOptions: [
        { text: "รอตรวจสอบ", value: "pending" },
        { text: "อนุมัติแล้ว", value: "approved" },
        { text: "ส่งกลับแก้ไข", value: "rejected" }
      ],

      licenseStatusOptions: [
        { text: "ใช้งานได้", value: "active" },
        { text: "หมดอายุ", value: "expired" },
        { text: "ถูกเพิกถอน", value: "revoked" },
        { text: "รอดำเนินการ", value: "pending" }
      ],

      headers: [
        { text: "วิทยาลัย", value: "college_name", width: 200 },
        { text: "ครูผู้ช่วย", value: "full_name", width: 200 },
        { text: "ประเภทใบอนุญาต", value: "license_type_name", width: 250 },
        {
          text: "วันที่หมดอายุ",
          value: "expiry_date",
          align: "center",
          width: 150
        },
        {
          text: "สถานะใบอนุญาต",
          value: "license_status",
          align: "center",
          width: 130
        },
        {
          text: "สถานะการอนุมัติ",
          value: "approval_status",
          align: "center",
          width: 150
        },
        {
          text: "ไฟล์",
          value: "license_file",
          align: "center",
          sortable: false,
          width: 80
        },
        {
          text: "จัดการ",
          value: "actions",
          align: "center",
          sortable: false,
          width: 150
        }
      ],

      snackbar: {
        show: false,
        text: "",
        color: "success"
      },

      rules: {
        required: v => !!v || "กรุณากรอกข้อมูล"
      },

      // Chart Options
      licenseTypeChartOptions: {
        chart: {
          type: "bar",
          fontFamily: "Sarabun, sans-serif",
          toolbar: { show: true }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            distributed: true,
            dataLabels: { position: "top" }
          }
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: { fontSize: "12px", colors: ["#B3151B"] }
        },
        colors: ["#B3151B", "#424242", "#E57373", "#9E9E9E", "#8E1014", "#BDBDBD", "#212121", "#F1B0B0"],
        xaxis: {
          categories: [],
          labels: { style: { fontSize: "12px" } }
        },
        yaxis: { title: { text: "จำนวน (รายการ)" } },
        legend: { show: false }
      },

      trendChartOptions: {
        chart: {
          type: "area",
          fontFamily: "Sarabun, sans-serif",
          height: 350,
          toolbar: { show: true },
          zoom: { enabled: true }
        },
        dataLabels: { enabled: false },
        stroke: { curve: "smooth", width: 2 },
        colors: ["#B3151B", "#424242", "#E57373"],
        fill: {
          type: "gradient",
          gradient: { opacityFrom: 0.6, opacityTo: 0.1 }
        },
        legend: { position: "top", horizontalAlign: "left" },
        xaxis: {
          categories: [],
          title: { text: "เดือน" }
        },
        yaxis: { title: { text: "จำนวน (รายการ)" } },
        tooltip: { shared: true, intersect: false }
      },

      collegeChartOptions: {
        chart: {
          type: "bar",
          fontFamily: "Sarabun, sans-serif",
          toolbar: { show: true }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: false,
            dataLabels: { position: "top" }
          }
        },
        dataLabels: {
          enabled: true,
          offsetX: 25,
          style: { fontSize: "12px", colors: ["#B3151B"] }
        },
        colors: ["#B3151B"],
        xaxis: {
          categories: [],
          title: { text: "จำนวนรายการ" }
        },
        yaxis: {
          labels: { style: { fontSize: "11px" } }
        }
      }
    };
  },

  computed: {
    approvalChartOptions() {
      return {
        chart: { type: "donut", fontFamily: "Sarabun, sans-serif" },
        labels: ["รอตรวจสอบ", "อนุมัติแล้ว", "ส่งกลับแก้ไข"],
        colors: ["#B3151B", "#424242", "#E57373"],
        legend: { position: "bottom", fontSize: "14px" },
        dataLabels: {
          enabled: true,
          formatter: function(val, opts) {
            return opts.w.config.series[opts.seriesIndex];
          }
        },
        plotOptions: {
          pie: {
            donut: {
              size: "65%",
              labels: {
                show: true,
                total: {
                  show: true,
                  label: "ทั้งหมด",
                  fontSize: "18px",
                  fontWeight: 600,
                  formatter: function(w) {
                    return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                  }
                }
              }
            }
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: { width: 300 },
              legend: { position: "bottom" }
            }
          }
        ]
      };
    },

    licenseStatusChartOptions() {
      return {
        chart: { type: "pie", fontFamily: "Sarabun, sans-serif" },
        labels: ["ใช้งานได้", "หมดอายุ", "ถูกเพิกถอน", "รอดำเนินการ"],
        colors: ["#B3151B", "#424242", "#E57373", "#9E9E9E"],
        legend: { position: "bottom", fontSize: "14px" },
        dataLabels: {
          enabled: true,
          formatter: function(val, opts) {
            return opts.w.config.series[opts.seriesIndex];
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: { width: 300 },
              legend: { position: "bottom" }
            }
          }
        ]
      };
    }
  },

  async mounted() {
    await this.initializeUser();
  },

  methods: {
      async deleteItem(item) {   
      if (!confirm(`ต้องการลบใบอนุญาต ${item.license_number} หรือไม่?`)) {
        return;
      }

      try {
        const response = await this.$http.post(
          "assistant_specialized_licenses.delete.php",
          {
            ApiKey: "HRvec2021",
            license_id: item.license_id
          }
        );

        if (response.data.status) {
          this.showSnackbar("ลบข้อมูลสำเร็จ", "success");
          await this.loadLicenses();
        } else {
          this.showSnackbar(response.data.message || "เกิดข้อผิดพลาด", "error");
        }
      } catch (error) {
        console.error("Error deleting license:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการลบข้อมูล", "error");
      }
    },

    async initializeUser() {
      try {
        this.loading = true;
        this.userSession = JSON.parse(localStorage.getItem("user")) || {};
        this.currentUser = this.userSession;

        // ตรวจสอบว่ามี id_card สำหรับ approved_by
        if (!this.currentUser.id_card) {
          console.warn("Warning: User ID card not found");
        }

        await this.initialize();
      } catch (error) {
        console.error("Error initializing user:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการโหลดข้อมูลผู้ใช้", "error");
      } finally {
        this.loading = false;
      }
    },

    async initialize() {
      // โหลดข้อมูลพร้อมกัน
      await Promise.all([
        this.loadLicenseTypes(),
        this.loadStatistics(),
        this.loadChartData()
      ]);
      // โหลด licenses หลังจาก chart เพื่อไม่ให้ช้า
      await this.loadLicenses();
    },

    async loadLicenseTypes() {
      try {
        const response = await this.$http.post(
          "specialized_license_types.php",
          {
            ApiKey: this.ApiKey,
            is_active: 1
          }
        );
        this.licenseTypes = response.data || [];
      } catch (error) {
        console.error("Error loading license types:", error);
      }
    },

    async loadLicenses() {
      this.loading = true;
      try {
        const params = {
          ApiKey: this.ApiKey,
          ...this.filter
        };

        const response = await this.$http.post(
          "assistant_specialized_licenses.php",
          params
        );
        this.licenses = Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        console.error("Error loading licenses:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการโหลดข้อมูล", "error");
        this.licenses = [];
      } finally {
        this.loading = false;
      }
    },

    async loadStatistics() {
      try {
        const response = await this.$http.post(
          "assistant_specialized_licenses.php",
          {
            ApiKey: this.ApiKey,
            get_statistics: true
          }
        );

        if (response.data) {
          this.stats = {
            total: parseInt(response.data.total) || 0,
            pending: parseInt(response.data.pending) || 0,
            approved: parseInt(response.data.approved) || 0,
            rejected: parseInt(response.data.rejected) || 0
          };

          // Update approval chart
          this.approvalChartSeries = [
            this.stats.pending,
            this.stats.approved,
            this.stats.rejected
          ];
        }
      } catch (error) {
        console.error("Error loading statistics:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการโหลดสถิติ", "error");
      }
    },

    async loadChartData() {
      try {
        // Load all charts in parallel
        await Promise.all([
          this.loadTypeDistribution(),
          this.loadStatusDistribution(),
          this.loadCollegeDistribution(),
          this.loadTrendData()
        ]);
      } catch (error) {
        console.error("Error loading chart data:", error);
      }
    },

    async loadTypeDistribution() {
      try {
        const response = await this.$http.post(
          "assistant_specialized_licenses.php",
          {
            ApiKey: this.ApiKey,
            get_type_distribution: true
          }
        );

        if (response.data && Array.isArray(response.data)) {
          const categories = response.data.map(item => item.license_type_name);
          const data = response.data.map(item => parseInt(item.count));

          this.licenseTypeChartOptions = {
            ...this.licenseTypeChartOptions,
            xaxis: {
              ...this.licenseTypeChartOptions.xaxis,
              categories: categories
            }
          };
          this.licenseTypeChartSeries = [{ name: "จำนวน", data }];
        }
      } catch (error) {
        console.error("Error loading type distribution:", error);
      }
    },

    async loadStatusDistribution() {
      try {
        const response = await this.$http.post(
          "assistant_specialized_licenses.php",
          {
            ApiKey: this.ApiKey,
            get_status_distribution: true
          }
        );

        if (response.data) {
          this.licenseStatusChartSeries = [
            parseInt(response.data.active) || 0,
            parseInt(response.data.expired) || 0,
            parseInt(response.data.revoked) || 0,
            parseInt(response.data.pending) || 0
          ];
        }
      } catch (error) {
        console.error("Error loading status distribution:", error);
      }
    },

    async loadCollegeDistribution() {
      try {
        const response = await this.$http.post(
          "assistant_specialized_licenses.php",
          {
            ApiKey: this.ApiKey,
            get_college_distribution: true,
            limit: 10
          }
        );

        if (response.data && Array.isArray(response.data)) {
          const categories = response.data.map(item => item.college_name);
          const data = response.data.map(item => parseInt(item.count));

          this.collegeChartOptions = {
            ...this.collegeChartOptions,
            xaxis: {
              ...this.collegeChartOptions.xaxis,
              categories: categories
            }
          };
          this.collegeChartSeries = [{ name: "จำนวนรายการ", data }];
        }
      } catch (error) {
        console.error("Error loading college distribution:", error);
      }
    },

    async loadTrendData() {
      try {
        const response = await this.$http.post(
          "assistant_specialized_licenses.php",
          {
            ApiKey: this.ApiKey,
            get_trend_data: true,
            months: parseInt(this.trendPeriod)
          }
        );

        if (response.data && Array.isArray(response.data)) {
          const categories = response.data.map(item => item.month_year);
          const pendingData = response.data.map(
            item => parseInt(item.pending) || 0
          );
          const approvedData = response.data.map(
            item => parseInt(item.approved) || 0
          );
          const rejectedData = response.data.map(
            item => parseInt(item.rejected) || 0
          );

          this.trendChartOptions = {
            ...this.trendChartOptions,
            xaxis: {
              ...this.trendChartOptions.xaxis,
              categories: categories
            }
          };

          this.trendChartSeries = [
            { name: "รอตรวจสอบ", data: pendingData },
            { name: "อนุมัติแล้ว", data: approvedData },
            { name: "ส่งกลับแก้ไข", data: rejectedData }
          ];
        }
      } catch (error) {
        console.error("Error loading trend data:", error);
      }
    },

    clearFilter() {
      this.filter = {
        approval_status: null,
        license_status: null,
        license_type_id: null,
        search_text: ""
      };
      this.loadLicenses();
    },

    filterByStatus(status) {
      if (status === "all") {
        this.filter.approval_status = null;
      } else {
        this.filter.approval_status = status;
      }
      this.loadLicenses();
    },

    openApprovalDialog(item, action) {
      this.selectedItem = { ...item };
      this.approvalAction = action;
      this.approvalData = {
        license_id: item.license_id,
        approval_status: action,
        reviewer_remarks: "",
        approved_by: this.currentUser.id_card || "",
        review_date: new Date().toISOString().substr(0, 10)
      };
      this.dialogApproval = true;
      this.dialogDetail = false;
    },

    async submitApproval() {
      if (this.approvalAction === "rejected" && this.$refs.approvalForm) {
        if (!this.$refs.approvalForm.validate()) {
          return;
        }
      }

      this.approving = true;
      try {
        const response = await this.$http.post(
          "assistant_specialized_licenses.php",
          {
            ApiKey: this.ApiKey,
            action: "update_approval",
            ...this.approvalData
          }
        );

        if (response.data.success) {
          this.showSnackbar(
            this.approvalAction === "approved"
              ? "อนุมัติรายงานสำเร็จ"
              : "ส่งกลับแก้ไขสำเร็จ",
            "success"
          );
          this.dialogApproval = false;
          // Reload data
          await Promise.all([
            this.loadStatistics(),
            this.loadLicenses(),
            this.loadChartData()
          ]);
        } else {
          this.showSnackbar(response.data.message || "เกิดข้อผิดพลาด", "error");
        }
      } catch (error) {
        console.error("Error submitting approval:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการบันทึกข้อมูล", "error");
      } finally {
        this.approving = false;
      }
    },

    viewDetail(item) {
      this.selectedItem = { ...item };
      this.dialogDetail = true;
    },

    viewFile(fileName) {
      if (fileName) {
        this.license_file = "";
        this.license_file = fileName;
        this.pdflicense_filedialog = true;
      }
    },

    async exportToExcel() {
      this.exporting = true;
      try {
        const XLSX = await import("xlsx");

        const data = this.licenses.map(item => ({
          วิทยาลัย: item.college_name || "-",
          "ชื่อ-นามสกุล": item.full_name || "-",
          เลขบัตรประชาชน: item.id_card || "-",
          ประเภทใบอนุญาต: item.license_type_name || "-",
          เลขที่ใบอนุญาต: item.license_number || "-",
          หน่วยงานออก: item.issuer_organization || "-",
          วันที่ออก: this.formatDate(item.issue_date),
          วันที่หมดอายุ: this.formatDate(item.expiry_date),
          จำนวนวันคงเหลือ:
            item.days_until_expiry !== null ? item.days_until_expiry : "-",
          สถานะใบอนุญาต: this.getLicenseStatusText(item.license_status),
          สถานะการอนุมัติ: this.getApprovalStatusText(item.approval_status),
          ผู้ตรวจสอบ: item.reviewer_name || "-",
          วันที่ตรวจสอบ: item.review_date
            ? this.formatDate(item.review_date)
            : "-",
          หมายเหตุผู้ตรวจสอบ: item.reviewer_remarks || "-",
          ผู้บันทึก: item.surveyor_name || "-",
          วันที่บันทึก: this.formatDate(item.survey_date)
        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const colWidths = [
          { wch: 30 },
          { wch: 25 },
          { wch: 15 },
          { wch: 30 },
          { wch: 20 },
          { wch: 25 },
          { wch: 12 },
          { wch: 12 },
          { wch: 12 },
          { wch: 15 },
          { wch: 15 },
          { wch: 25 },
          { wch: 12 },
          { wch: 30 },
          { wch: 25 },
          { wch: 12 }
        ];
        ws["!cols"] = colWidths;

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "รายงานใบอนุญาต");

        const fileName = `license_dashboard_${new Date()
          .toISOString()
          .substr(0, 10)}.xlsx`;
        XLSX.writeFile(wb, fileName);

        this.showSnackbar("ส่งออกข้อมูลสำเร็จ", "success");
      } catch (error) {
        console.error("Error exporting:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการส่งออกข้อมูล", "error");
      } finally {
        this.exporting = false;
      }
    },

    getPercentage(value) {
      if (this.stats.total === 0) return 0;
      return ((value / this.stats.total) * 100).toFixed(1);
    },

    getInitials(fullName) {
      if (!fullName) return "?";
      const parts = fullName.trim().split(" ");
      if (parts.length >= 2) {
        return parts[0].charAt(0) + parts[parts.length - 1].charAt(0);
      }
      return fullName.charAt(0);
    },

    formatDate(date) {
      if (!date) return "-";
      const d = new Date(date);
      if (isNaN(d.getTime())) return "-";

      const day = d
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const year = d.getFullYear() + 543;
      return `${day}/${month}/${year}`;
    },

    getLicenseStatusColor(status) {
      const colors = {
        active: "success",
        expired: "error",
        revoked: "grey",
        pending: "warning"
      };
      return colors[status] || "grey";
    },

    getLicenseStatusText(status) {
      const texts = {
        active: "ใช้งานได้",
        expired: "หมดอายุ",
        revoked: "ถูกเพิกถอน",
        pending: "รอดำเนินการ"
      };
      return texts[status] || status;
    },

    getApprovalStatusColor(status) {
      const colors = {
        pending: "warning",
        approved: "success",
        rejected: "error",
        draft: "grey"
      };
      return colors[status] || "grey";
    },

    getApprovalStatusText(status) {
      const texts = {
        pending: "รอตรวจสอบ",
        approved: "อนุมัติแล้ว",
        rejected: "ส่งกลับแก้ไข",
        draft: "ฉบับร่าง"
      };
      return texts[status] || status;
    },

    getApprovalStatusIcon(status) {
      const icons = {
        pending: "mdi-clock-alert",
        approved: "mdi-check-circle",
        rejected: "mdi-close-circle",
        draft: "mdi-file-document-outline"
      };
      return icons[status] || "mdi-help-circle";
    },

    getExpiryColor(days) {
      if (days === null || days === undefined) return "grey";
      if (days < 0) return "error";
      if (days <= 30) return "error";
      if (days <= 90) return "warning";
      return "success";
    },

    getExpiryText(days) {
      if (days === null || days === undefined) return "-";
      if (days < 0) return "หมดอายุแล้ว";
      if (days === 0) return "หมดอายุวันนี้";
      return `เหลือ ${days} วัน`;
    },

    showSnackbar(text, color = "success") {
      this.snackbar = {
        show: true,
        text,
        color
      };
    }
  }
};
</script>

<style scoped>
.stat-card {
  cursor: pointer;
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;
}

.v-data-table >>> tbody tr:hover {
  background-color: #f5f5f5 !important;
}

.v-card-title {
  font-size: 1.1rem;
  font-weight: 600;
}

.text-h3 {
  font-size: 2.5rem !important;
}

.text-h4 {
  font-size: 2rem !important;
}
</style>
